import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import propTypes from "prop-types";

import { useDir } from "../../hooks";

const ModalCloseIcon = ({ onClose }) => {
  const dir = useDir();

  return (
    <IconButton
      type="button"
      aria-label="Close"
      onClick={onClose}
      sx={{
        position: "absolute",
        top: 10,
        zIndex: 1,
        backgroundColor: "rgba(255, 255, 255, 0.85)",
        "&:hover": { backgroundColor: "#fff" },
        ...(dir === "ltr" ? { right: 10 } : { left: 10 }),
      }}
    >
      <CloseIcon />
    </IconButton>
  );
};

ModalCloseIcon.propTypes = {
  onClose: propTypes.func.isRequired,
};

export default ModalCloseIcon;
